var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"bg-icon"}),_c('p',{staticClass:"text text-big"},[_vm._v("Sorry！你访问的页面出错啦！")])])
}]

export { render, staticRenderFns }